module.exports = __webpack_public_path__ + "img/Danger3d.674bf347.svg";